import {
  parse,
  parseISO,
  format,
  isToday,
  isTomorrow,
  getDay,
  addDays,
  addMinutes,
  eachDayOfInterval,
  differenceInMinutes,
} from 'date-fns';

const getLabel = (weekday) => {
  let label = 'Dom';

  if (weekday == 1) { label = 'Seg'; }
  if (weekday == 2) { label = 'Ter'; }
  if (weekday == 3) { label = 'Qua'; }
  if (weekday == 4) { label = 'Qui'; }
  if (weekday == 5) { label = 'Sex'; }
  if (weekday == 6) { label = 'Sáb'; }

  return label;
}

const formatDateAbbreviate = (date, parseDate = true) => {
  if (parseDate) {
    date = parseISO(date);
  }

  let label :string = '';

  if (isToday(date)) {
    label = 'Hoje';
  }

  // if (isTomorrow(date)) {
  //   label = 'Amanhã';
  // }

  return {
    weekday: label != '' ? label : getLabel(getDay(date)),
    date: format(date, 'dd'),
  }
}


const formatDate = (date, parseDate = true) => {
  if (parseDate) {
    date = parseISO(date);
  }

  if (isToday(date)) {
    return 'Hoje';
  }

  if (isTomorrow(date)) {
    return 'Amanhã';
  }

  return getLabel(getDay(date)) + ' • ' + format(date, 'dd/MM');
}

const formatLongDate = (value, alwaysDate = false) => {
  if (value) {
    let date = parse(value, 'yyyy-MM-dd', new Date());

    if (isToday(date) && !alwaysDate) {
      return 'Hoje';
    }

    if (isTomorrow(date) && !alwaysDate) {
      return 'Amanhã';
    }

    return format(date, 'dd/MM/yyyy');
  }
}

const formatLongDateTime = (value, parseDate = false) => {
  if (value) {
    let date : any = '';

    if (!parseDate) {
      date = parse(value, 'yyyy-MM-dd HH:mm:ss', new Date());
    } else {
      date = parseISO(value);
    }

    let string = format(date, 'dd/MM/yyyy');

    if (isToday(date)) {
      string = 'Hoje';
    }

    if (isTomorrow(date)) {
      string = 'Amanhã';
    }

    return string + ' • ' + format(date, 'HH:mm')
  }
}


const formatLongDateToDate = (value, parseDate = false, alwaysDate = true) => {
  if (value) {
    let date : any = '';

    if (!parseDate) {
      date = parse(value, 'yyyy-MM-dd HH:mm:ss', new Date());
    } else {
      date = parseISO(value);
    }

    let string = format(date, 'dd/MM/yyyy');

    if (isToday(date) && alwaysDate) {
      string = 'Hoje';
    }

    if (isTomorrow(date) && alwaysDate) {
      string = 'Amanhã';
    }

    return string;
  }
}

const calculateDiffMinutes = (start, finish) => {
  let startAt = parse(start, 'yyyy-MM-dd HH:mm:ss', new Date());
  let finishAt = parse(finish, 'yyyy-MM-dd HH:mm:ss', new Date());

  return differenceInMinutes(finishAt, startAt);
}

const calculateMinutes = (value, duration) => {
  let date = parse(value, 'yyyy-MM-dd HH:mm', new Date());

  return format(addMinutes(date, duration.minutes), 'yyyy-MM-dd HH:mm');
}

// const calculateDates = (days = 14 ) => {
//   let dates = eachDayOfInterval({ start: new Date(), end: addDays(new Date(), days) });

//   const label : string[] = [];
//   const value : string[] = [];

//   dates.map((day) => {
//     label.push(formatDate(day, false));
//     value.push(format(day, 'yyyy-MM-dd'));
//   });

//   return {
//     label: label,
//     value: value
//   };
// }

const calculateDates = (days = 14 ) => {
  let dates = eachDayOfInterval({ start: new Date(), end: addDays(new Date(), days) });

  const values : any[] = [];

  dates.map((day) => {
    let formatedDate :any = formatDateAbbreviate(day, false);

    values.push({
      weekday: formatedDate.weekday,
      date: formatedDate.date,
      value: format(day, 'yyyy-MM-dd')
    });
  });

  return values;
}

const dayOfWeekAsString = (weekday) => {
  let label = '';

  if (weekday == 1) { label = 'Domingo'; }
  if (weekday == 2) { label = 'Segunda'; }
  if (weekday == 4) { label = 'Terça'; }
  if (weekday == 8) { label = 'Quarta'; }
  if (weekday == 16) { label = 'Quinta'; }
  if (weekday == 32) { label = 'Sexta'; }
  if (weekday == 64) { label = 'Sábado'; }

  return label;
}

const getWeekDays = (weekdays, byLabel = false) => {
  let string = '';

  weekdays = weekdays.map(weekday => {
    if (byLabel) {
      return getLabel(weekday);
    }

    return dayOfWeekAsString(weekday);
  });

  return weekdays.join(', ');
}

const parseWeekDays = (weekdays, all = false) => {
  if (all && weekdays.length == 0 || weekdays.length == 7) {
    return 'Todos os dias da semana'
  }

  let data = weekdays.map(weekday => getLabel(weekday));

  if (data.length == 1) {
    return data[0];
  }

  return data.slice(0, -1).join(', ')+' e '+data.slice(-1);
}

const convertWeekday = (days) => {
  let values = [
    1,
    2,
    4,
    8,
    16,
    32,
    64,
  ];

  let data: any = [];

  days.map(day => {
    data.push(values[day]);
  })

  return getWeekDays(data);
}

const verifyIsToday = (date: string) => {
  let parsedDate: Date = parseISO(date);

  return isToday(parsedDate);
}

export {
  getLabel,
  formatDate,
  formatDateAbbreviate,
  formatLongDate,
  formatLongDateTime,
  formatLongDateToDate,
  calculateDiffMinutes,
  calculateMinutes,
  calculateDates,
  dayOfWeekAsString,
  getWeekDays,
  parseWeekDays,
  convertWeekday,
  verifyIsToday,
}